import React from "react"
import { Auth } from "aws-amplify"
import { useHistory, Link as RouterLink } from "react-router-dom"
import { useSnackbar } from "notistack"
import { makeStyles } from "@material-ui/styles"
import Grid from "@material-ui/core/Grid"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"

import useFormFields from "../libs/useFormFields"

import Button from "../components/Button"
import PasswordField from "../components/PasswordField"

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    margin: "auto",
    marginTop: theme.spacing(1),
    maxWidth: 600,
  },
}))

export default function ChangePassword() {
  const classes = useStyles()
  const [isLoading, setIsLoading] = React.useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()
  const [fields, handleFieldChange] = useFormFields({
    password: "",
    oldPassword: "",
    confirmPassword: "",
  })

  function validateForm() {
    return (
      fields.oldPassword.length > 0 &&
      fields.password.length > 0 &&
      fields.password === fields.confirmPassword
    )
  }

  async function handleSubmit(event) {
    event.preventDefault()
    setIsLoading(true)

    try {
      const authUser = await Auth.currentAuthenticatedUser()
      await Auth.changePassword(authUser, fields.oldPassword, fields.password)
      enqueueSnackbar("Password successfully changed", {
        variant: "success",
      })
      history.push("/0/profile")
    } catch (error) {
      console.log("error", error)
      enqueueSnackbar(`Password was not updated`, {
        variant: "error",
      })
      setIsLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Grid className={classes.container} container spacing={3}>
        <Grid item xs={12}>
          <PasswordField
            autoFocus
            value={fields.oldPassword}
            id="oldPassword"
            label="Old Password"
            onChange={handleFieldChange}
          />
        </Grid>
      </Grid>
      <Grid className={classes.container} container spacing={3}>
        <Grid item xs={6}>
          <PasswordField
            onChange={handleFieldChange}
            value={fields.password}
            id="password"
            label="New Password"
          />
        </Grid>
        <Grid item xs={6}>
          <PasswordField
            onChange={handleFieldChange}
            defaultValue={fields.confirmPassword}
            id="confirmPassword"
            label="Confirm Password"
          />
        </Grid>
      </Grid>
      <Grid className={classes.container} container spacing={3} justifyContent="flex-end">
        <Grid item>
          <Button component={RouterLink} to="/0/profile" variant="text">
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <Button
            disabled={!validateForm()}
            endIcon={<ChevronRightIcon />}
            isLoading={isLoading}
            type="submit"
          >
            Update
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}
